export const getFocusableGameItemId = (id: string) => `game-item-id_${id}`
